<!-- mobile skeleton will be used as default one for deeplink (no product type in parameter) -->
<mprd-skeleton-mobile-option-details
  *ngIf="
    (!option &&
    !isDeepLinkDataLoaded &&
    (productTypeParameter === 'mobile' || !productTypeParameter))
     || (isEshareTvOptionFlowEnabled && productType === 'tv' || isMobileOptionEshareRedirectActive)
  "
></mprd-skeleton-mobile-option-details>
<mprd-skeleton-internet-option-details
  *ngIf="
    !option && !isDeepLinkDataLoaded && productTypeParameter === 'internet'
  "
></mprd-skeleton-internet-option-details>
<mprd-skeleton-tv-option-details
  *ngIf="!option && !isDeepLinkDataLoaded && productTypeParameter === 'tv' && (!isEshareTvOptionFlowEnabled && productType === 'tv')"
></mprd-skeleton-tv-option-details>
<mprd-skeleton-telephony-option-details
  *ngIf="
    !option && !isDeepLinkDataLoaded && productTypeParameter === 'telephony'
  "
></mprd-skeleton-telephony-option-details>
<section
  class="rs-content-wrapper rs-header-has-level2"
  id="option-details"
  *ngIf="(option || isDeepLinkDataLoaded) && !(isEshareTvOptionFlowEnabled && productType === 'tv') && !isMobileOptionEshareRedirectActive"
>
  <main id="maincontent" role="main">
    <section
      class="rs-es-first-section"
      *ngIf="
        (productType === 'mobile' ||
          productType === 'internet' ||
          productType === 'digitalis' ||
          productType === 'telephony') &&
        !isEBU
      "
    >
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1
            class="rs-tit1-sp rs-txt-c2 rs-has-subtit"
            data-cy="productDescription"
          >
            {{ selectedProduct?.productDescription }}
          </h1>
          <p
            *ngIf="!isDeepLinkMultipleEligibleProducts"
            class="rs-txt-s5 rs-txt-c2 small-only-text-center"
            x-ms-format-detection="none"
          >
            <mprd-access-number-formatter
              [accessNumber]="selectedProduct?.accessNumber"
              [plc]="selectedProduct?.plc"
            ></mprd-access-number-formatter>
          </p>

          <div class="panel rs-panel-big clearfix">
            <h2 class="rs-tit3">{{ optionName }}</h2>
            <p data-cy="optionDescription">{{ option?.description }}</p>
            <mprd-bizz-guest-wifi
              *ngIf="isActiveOption() && isBizzGuestWifiOption()"
              [internetProductDetails]="selectedProduct"
            ></mprd-bizz-guest-wifi>
            <p class="small-only-text-center">
              <ng-container *ngIf="isStartingFromPriceVisible">
                {{ "option.deeplink.startingFrom" | translate }}
              </ng-container>
              <mprd-price
                [option]="option"
                (isIncludedOption)="isOptionIncluded($event)"
                amountClass="rs-price-m"
                [showPriceForIncluded]="isConfigurableOption || isMpay"
                data-cy="productPrice"
              ></mprd-price>
              <a
                *ngIf="isStartingFromPriceVisible || isFreeAsteriksVisible"
                href="javascript:inception.scrollToElement('#footnotes');"
                class="rs-link-no-decoration"
                aria-describedby="footnote1-label"
                id="footnote-ref"
                >*</a
              >
            </p>
            <a
              *ngFor="let downloadLink of option?.downloadLinks"
              href="{{ downloadLink.webUrl }}"
              ><img
                alt="{{ downloadLink.os }}"
                [src]="getDownloadAppstoreImageByOs(downloadLink.os)"
                class="rs-margin-right1"
                target="_blank"
            /></a>
            <div>
              <a
                *ngIf="option?.configureLink?.url && !isNimbleRedirection"
                href="{{
                  option?.configureLink?.url[
                    languageService.getSelectedLanguage()
                  ]
                }}"
                target="_blank"
                class="rs-btn rs-btn-third"
              >
                {{
                  option?.configureLink?.label[
                    languageService.getSelectedLanguage()
                  ]
                }}
                <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"
                  ><span class="show-for-sr">{{
                    "option.details.openWindow.accessibility" | translate
                  }}</span></i
                >
              </a>
            </div>
            <div>
              <a
                *ngIf="
                  option?.manageOptionLink &&
                  [PlcCodes.MMI, PlcCodes.MMV].indexOf(selectedProduct?.plc) !==
                    -1
                "
                href="{{
                  option?.manageOptionLink?.url[
                    languageService.getSelectedLanguage()
                  ]
                }}"
                target="_blank"
                class="rs-btn rs-btn-third"
              >
                {{
                  option?.manageOptionLink?.label[
                    languageService.getSelectedLanguage()
                  ]
                }}>
                <i
                  class="rs-icon-btn-third rs-margin-left1"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            <div>
              <a
                *ngIf="
                  option?.redirectLink?.url &&
                  !isNetflixOption() &&
                  !(
                    isBizzGuestWifiOption() &&
                    !isActiveOption() &&
                    hasInvolvement
                  )
                "
                href="{{ buildRedirectURL() }}"
                target="_blank"
                class="rs-btn rs-btn-third"
              >
                {{
                  option?.redirectLink?.label[
                    languageService.getSelectedLanguage()
                  ]
                }}
                <i
                  class="rs-icon-btn-third rs-margin-left1"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            <px-alert
              [alertKey]="
                option?.optionCodeForDescription +
                'netflixAccountManagementAlertLevel3'
              "
            ></px-alert>
            <mprd-netflix-account-management
              [option]="option"
              *ngIf="
                option?.redirectLink?.url &&
                isNetflixOption(option) &&
                isActiveOption()
              "
            ></mprd-netflix-account-management>
            <mprd-mobile-payment
              *ngIf="showMpayForm()"
              [option]="option"
              [selectedProduct]="selectedProduct"
            ></mprd-mobile-payment>
            <px-alert
              data-cy="pxAlertBox"
              *ngIf="option || deepLinkMpcUuid"
              [alertKey]="getAlertKey()"
            ></px-alert>
            <div
              *ngIf="hideCeaseButton"
              class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only"
            >
              <div class="rs-flex-columns">
                <mprd-order-button
                  *ngIf="option?.ibStatus != OptionStatus.ERROR"
                  [(option)]="option"
                  [selectedProduct]="selectedProduct"
                  [isDeepLink]="isDeepLinkDataLoaded"
                  [isNimbleRedirection]="isNimbleRedirection"
                  [isWebshopLoaded]="isWebshopLoaded"
                  [deepLinkStatus]="deepLinkStatus"
                  (resultEmit)="onResult($event)"
                  [treatmentCode]="treatmentCode"
                  (webshopLoadedEvent)="onWebshopLoadedEvent($event)"
                  data-cy="orderButton"
                ></mprd-order-button>
              </div>
              <div
                *ngIf="
                  productType === 'mobile' &&
                  option &&
                  selectedProduct &&
                  !isDeepLinkMultipleEligibleProducts
                "
                class="rs-flex-columns rs-flex-grow"
              >
                <p class="small-only-text-center" x-ms-format-detection="none">
                  {{ "option.details.for" | translate }}&nbsp;
                  <mprd-access-number-formatter
                    [accessNumber]="selectedProduct?.accessNumber"
                    [plc]="selectedProduct?.plc?.toString()"
                  ></mprd-access-number-formatter>
                </p>
              </div>
              <div
                class="rs-flex-columns"
                *ngIf="productType === 'tv' || productType === 'internet'"
              >
                <p>{{ "option.details.for" | translate }}&nbsp;</p>
              </div>
              <div
                class="rs-flex-columns rs-flex-grow"
                *ngIf="productType === 'tv' || productType === 'internet'"
              >
                <p class="small-only-text-center">
                  <mprd-address
                    *ngIf="
                      option &&
                      selectedProduct &&
                      !isDeepLinkMultipleEligibleProducts
                    "
                    [address]="selectedProduct?.installationAddress"
                    [showInOneLine]="false"
                  ></mprd-address>
                </p>
              </div>
            </div>
            <div
              class="rs-flex-columns"
              *ngIf="option?.customTermsAndConditions"
            >
              <p class="rs-padding-bottom1 rs-word-break-all">
                <a
                  href="{{
                    option.customTermsAndConditions.url[
                      languageService.getSelectedLanguage()
                    ]
                  }}"
                  target="_blank"
                  >{{
                    option.customTermsAndConditions.label[
                      languageService.getSelectedLanguage()
                    ]
                  }}<span class="rs-icon-link-tb" title="Opens a new window"
                    ><span class="show-for-sr">{{
                      "products.option.details.customTermsAndCondition.accessibility"
                        | translate
                    }}</span></span
                  ></a
                >
              </p>
            </div>
            <div class="rs-me2"></div>
            <div class="row collapse" *ngIf="option?.image">
              <img class="show-for-large-up" [src]="option.image?.large" />
              <img class="show-for-medium-only" [src]="option.image?.medium" />
              <img class="show-for-small-only" [src]="option.image?.small" />
            </div>
            <small *ngIf="!treatmentCode" class="rs-txt-s2 rs-block">{{
              "common.options.priceMention" | translate
            }}</small>
            <span id="footnotes" aria-hidden="true" tabindex="-1"></span>
            <h2 id="footnote-label" class="show-for-sr">
              {{ "option.details.footNote.accessibility" | translate }}
            </h2>
            <small
              *ngIf="option?.customPrices?.asteriksFootnote"
              class="rs-font-pxL rs-block"
            >
              *&nbsp;{{
                option?.customPrices?.asteriksFootnote[
                  languageService.getSelectedLanguage()
                ]
              }}
              <a
                href="javascript:inception.scrollToElement('#footnote-ref');"
                aria-label="Back to content"
                >↩</a
              >
            </small>
            <small
              *ngIf="isDeepLinkFootNoteVisible"
              class="rs-font-pxL rs-block"
            >
              *&nbsp;{{ "option.deeplink.startingFrom.footNote" | translate }}
              <a
                href="javascript:inception.scrollToElement('#footnote-ref');"
                aria-label="Back to content"
                >↩</a
              >
            </small>
          </div>
        </div>
      </div>
      <div class="rs-le2"></div>
    </section>
    <mprd-option-details-background
      *ngIf="productType === 'tv'"
      [option]="option"
      [isDeepLinkMultipleProductsEligible]="isDeepLinkMultipleEligibleProducts"
      [isFreeAsteriksVisible]="isFreeAsteriksVisible"
      [isStartingFromPriceVisible]="isStartingFromPriceVisible"
      [isDiscountTextVisible]="isDiscountTextVisible"
      [flexPackDiscountText]="flexPackDiscountText"
      [isOnTopCurrentPackVisible]="isOnTopCurrentPackVisible"
      [netflixBuyAndSellStatus]="netflixBuyAndSellStatus"
      [isDeepLinkFootNoteVisible]="isDeepLinkFootNoteVisible"
      [selectedProduct]="selectedProduct"
      [isRes]="isRes"
      [treatmentCode]="treatmentCode"
      [isDeepLinkDataLoaded]="isDeepLinkDataLoaded"
      [deepLinkStatus]="deepLinkStatus"
      [productType]="productType"
      [queryParamToken]="queryParamToken"
    ></mprd-option-details-background>
    <mprd-ebu-option-details
      *ngIf="isEBU && productType === 'mobile'"
      [selectedProduct]="selectedProduct"
      [isConfigurableoption]="isConfigurableOption"
      [flexPackDiscountText]="flexPackDiscountText"
      [option]="option"
    ></mprd-ebu-option-details>
  </main>
</section>

